<template>
    <div class="flex items-center justify-between gap-4" data-testid="pagination-container">
        <div class="text-base main-text-color" data-testid="pagination-info">
            {{ from }} - {{ to }} {{ t('general.of') }} {{ totalItems }}
        </div>
        <div class="w-6 md:w-12 arrow-group flex items-center justify-between" data-testid="pagination-controls">
            <div
                :class="currentPage === 1 ? 'disabled cursor-not-allowed text-gray-700' : 'text-primary hover:bg-primary-50'"
                class="p-1 rounded rtl:rotate-180"
                role="button"
                data-testid="pagination-button-prev"
                @click="prevPage"
            >
                <IconSimpleArrowLeft class="w-4 h-4" />
            </div>
            <div
                :class="currentPage === totalPages ? 'disabled text-gray-700' : 'text-primary hover:bg-primary-50'"
                class="p-1 rounded rtl:rotate-180"
                role="button"
                data-testid="pagination-button-next"
                @click="nextPage"
            >
                <IconSimpleArrowRight class="w-4 h-4" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    totalItems: number
    perPage: number
    from: number
    to: number
    currentPage: number
}>()

const emit = defineEmits<{
    (event: 'update-current-page', value: number): void
}>()

const totalPages = computed(() => Math.ceil(props.totalItems / props.perPage))


function prevPage () {
    if (props.currentPage > 1) {
        emit('update-current-page', props.currentPage - 1)
    }
}
function nextPage () {
    if (props.currentPage < totalPages.value) {
        emit('update-current-page', props.currentPage + 1)
    }
}
</script>

<style scoped>
</style>
